<div class="sidebar-container">
  <!-- Logo Section -->
  <div class="logo-section">
    <div class="logo-wrapper">
      <div class="logo-circle">
        <i class="pi pi-briefcase"></i>
      </div>
    </div>
    <div>
  <span class="logo-text">{{ 'layout.sidebar.brandName' | transloco }}</span>
  <p class="logo-subtitle">{{ 'layout.sidebar.brandSubtitle' | transloco }}</p>
    </div>
  </div>

  <!-- New Academy Button -->
  <!-- <div class="new-academy-section">
    <button pButton
            type="button"
            class="p-button-outlined p-button-sm w-full"
            icon="pi pi-plus"
            [label]="'layout.sidebar.buttons.newAcademy' | transloco"
            (click)="onNewAcademy()"></button>
  </div> -->

  <!-- Navigation Menu (modern, no bullets) -->
  <nav class="sidebar-nav">
    <div class="nav-container">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menuItems, isRoot: true, depth: 0 }"></ng-container>
    </div>
  </nav>

  <ng-template #menuTpl let-items let-isRoot="isRoot" let-depth="depth">
    <ng-container *ngFor="let item of items">
      <!-- Główne kategorie (depth 0 z children) jako nagłówki -->
      <div *ngIf="depth === 0 && item.children?.length" class="nav-category-header">
        <button type="button"
                class="nav-category-toggle"
                (click)="toggleCategory(item)">
          <span class="nav-category-label">
            {{ item.label | transloco }}
          </span>
          <i class="pi chevron-icon"
             [ngClass]="{ 'pi-chevron-down': item.expanded, 'pi-chevron-up': !item.expanded }"></i>
        </button>
      </div>

      <!-- Normalne elementy menu -->
      <div *ngIf="!(depth === 0 && item.children?.length)"
           class="nav-item"
           [class.active]="item.active"
           [class.has-children]="item.children?.length"
           [style.--depth]="depth">
        <div class="nav-link-wrapper">
          <button type="button"
                  class="nav-link"
                  pRipple
                  (click)="onMenuItemClick(item)"
                  [pTooltip]="item.label | transloco"
                  tooltipPosition="right"
                  [showDelay]="500">
            <i *ngIf="item.icon" [class]="item.icon + ' nav-icon'"></i>
            <span class="nav-label">{{ item.label | transloco }}</span>
          </button>
          <button *ngIf="item.children?.length"
                  type="button"
                  class="nav-chevron-btn"
                  (click)="toggleExpand(item, $event)">
            <i class="pi chevron-icon"
               [ngClass]="{ 'pi-chevron-down': item.expanded, 'pi-chevron-right': !item.expanded }"></i>
          </button>
        </div>
      </div>

      <!-- Children container -->
      <div class="nav-children" *ngIf="item.children?.length && item.expanded" [@slideDown]>
        <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: item.children, isRoot: false, depth: depth + 1 }"></ng-container>
      </div>
    </ng-container>
  </ng-template>

  <!-- User Profile Section -->
  <div class="user-profile-container">
    <button type="button" 
            class="user-profile"
            pRipple
            (click)="toggleUserMenu()"
            [class.expanded]="userMenuExpanded">
      <div class="user-avatar">
        <p-avatar
          [label]="userInfo.avatar"
          size="large"
          shape="circle"
          styleClass="user-avatar-circle">
        </p-avatar>
      </div>
      <div class="user-info">
        <h4 class="user-name">{{ userInfo.name }}</h4>
        <span class="user-status">{{ 'layout.sidebar.userStatus.premium' | transloco }}</span>
      </div>
      <div class="user-chevron">
        <i class="pi chevron-icon"
           [ngClass]="{ 'pi-chevron-up': userMenuExpanded, 'pi-chevron-down': !userMenuExpanded }"></i>
      </div>
    </button>

    <!-- Rozwijane opcje użytkownika -->
    <div class="user-menu-options" *ngIf="userMenuExpanded" [@slideDown]>
      <button type="button"
              class="user-menu-item"
              pRipple
              (click)="onUserMenuAction('profile')">
        <i class="pi pi-user"></i>
        <span>{{ 'layout.sidebar.userMenu.profile' | transloco }}</span>
      </button>
      <button type="button"
              class="user-menu-item"
              pRipple
              (click)="onUserMenuAction('settings')">
        <i class="pi pi-cog"></i>
        <span>{{ 'layout.sidebar.userMenu.settings' | transloco }}</span>
      </button>
      <div class="user-menu-divider"></div>
      <button type="button"
              class="user-menu-item logout"
              pRipple
              (click)="onUserMenuAction('logout')">
        <i class="pi pi-sign-out"></i>
        <span>{{ 'layout.sidebar.userMenu.logout' | transloco }}</span>
      </button>
    </div>
  </div>
</div>
